import { formatDateOnly } from '../../../common/utils/date';

// Frecuencia de sesiones (view=trends → aspiration_frequency / transfer_frequency):
// 6 buckets contiguos con `count` + `avg` por tramo. Mini-barras. Reutilizable.

const W = 220, H = 96, PAD = 12, GAP = 6;
const TONES = { primary: 'var(--color-primary)', accent: 'var(--color-accent)' };

export default function FrequencyChart({ series, label, tone = 'primary' }) {
    const buckets = series?.buckets || [];
    const n = buckets.length;
    const color = TONES[tone] || TONES.primary;
    const max = Math.max(1, ...buckets.map(b => Number(b.count) || 0));
    const innerW = W - PAD * 2;
    const innerH = H - PAD * 2;
    const bw = n ? (innerW - GAP * (n - 1)) / n : 0;
    const avg = Number(series?.avg ?? 0).toLocaleString('es-CO', { maximumFractionDigits: 2 });

    return (
        <article className="report-card report-trend">
            <h2 className="report-section__title">{label}</h2>

            {!n ? (
                <p className="report-empty">Sin datos en el período.</p>
            ) : (
                <>
                    <svg className="report-trend__chart" viewBox={`0 0 ${W} ${H}`} role="img" aria-label={label}>
                        {buckets.map((b, i) => {
                            const h = ((Number(b.count) || 0) / max) * innerH;
                            const xb = PAD + i * (bw + GAP);
                            const yb = PAD + innerH - h;
                            return (
                                <rect key={`${b.start}-${i}`} x={xb} y={yb} width={bw} height={Math.max(2, h)} rx="2" fill={color}>
                                    <title>{`${formatDateOnly(b.start)}–${formatDateOnly(b.end)}: ${b.count}`}</title>
                                </rect>
                            );
                        })}
                    </svg>
                    <div className="report-trend__legend">
                        <span className="report-trend__avg">Prom. {avg} / tramo</span>
                        {series?.span && <span className="report-trend__caption">{formatDateOnly(series.span.from)} – {formatDateOnly(series.span.to)}</span>}
                    </div>
                </>
            )}
        </article>
    );
}
